import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { PasSetupDataWorkersModule } from './pas-setup-data-workers';
import { TransientPortfolioDataLoaderService } from './services';
import { ApbEngagementResolverWorker, BpasEngagementResolverWorker, DataLoadingWorker, ExternalPortfolioResolverWorker, InternalPortfolioResolverWorker, NileDataLoadingWorker, PartnerPortfolioResolverWorker, SetViewCategoryWorker, WatchlistResolverWorker } from './workers';
import { AcplInternalPortfolioResolverWorker } from './workers/acpl-internal-portfolio-resolver-worker';
import { BenchmarkResolverWorker } from './workers/benchmark-resolver-worker';
import { NileAssetTypesLoader } from './workers/nile-asset-types-loader';
import { NileIndexesLoader } from './workers/nile-indexes-loader';

@NgModule({
	// eslint-disable-next-line @nrwl/nx/workspace/cwpNgFrameworkAsModuleImportRule
	imports: [CommonModule, PasSetupDataWorkersModule.forRoot()],
	exports: []
})
export class SetupDataWorkersModule {
	public static forRoot(): ModuleWithProviders<SetupDataWorkersModule> {
		return {
			ngModule: SetupDataWorkersModule,
			providers: [
				SetViewCategoryWorker,
				InternalPortfolioResolverWorker,
				ExternalPortfolioResolverWorker,
				PartnerPortfolioResolverWorker,
				ApbEngagementResolverWorker,
				BpasEngagementResolverWorker,
				DataLoadingWorker,
				TransientPortfolioDataLoaderService,
				BenchmarkResolverWorker,
				NileIndexesLoader,
				NileAssetTypesLoader,
				NileDataLoadingWorker,
				WatchlistResolverWorker,
				AcplInternalPortfolioResolverWorker
			]
		};
	}
}
